/**
 * 
 * App-console for development and debugging	
 * @name AppConsole
 */
(function(define){

	define('app-console/app-console',['require','module','./lib/console','./lib/LogMessage','./lib/group','./config','./lib/levels'],function(requirejs,module,konsole,LogMessage,group,config,levels){
			/* consts */
		var ERROR 			= "error",
			UNDEFINED 		= undefined,
			TRUE 			= true,
			rjserror,

			globalConfig 	= config();


		var extend = function(target,source,all){
				var key;
				all=all===true;
				for(key in source){
					if(source.hasOwnProperty(key)||all){
						target[key]=source[key];
					}
				}
				return target;			
			},
			/**
			 * Generate a wrapped call to the internal logger.
			 * Creates a LogMessage instance for output config.
			 * @private
			 * 
			 * @param  {string} level Log level to use when calling the 
			 *                        return function.
			 * @return {function}     Wrapped call to the internal logger. Forwards all
			 *                        arguments vie the LogMessage instance
			 */
			bindLogger = function(level) {
				return function(){
					this.logMessage.log(level,arguments);
				}
			};

		/**
		 * AppConsole instance constructor.  
		 * @constructor 
		 * @param {object} [conf] Instance-level overrides
		 */
		function AppConsole(conf){
			this.config(conf);
			this.logMessage = new LogMessage(this);
			this.globalConsole=GlobalAppConsole || this;
		};

		AppConsole.prototype={
			ns 			: null,
			level 		: 'global',
			grouping	: false,
			assert  : function(ns,assertion){
				if(typeof ns!=='string'){
					arguments[1]=assertion=ns;
					arguments[0]=ns=undefined;
				}
				if(assertion!=TRUE){
					arguments[1]="Assertion failed";
					this.error.apply(this,arguments);
				}
			},
			debug 	: bindLogger('debug'),
			dir 	: bindLogger('dir'),
			dirxml 	: bindLogger(konsole.dirxml ? 'dirxml' : 'dir'),
			error	: bindLogger(ERROR),
			info 	: bindLogger('info'),
			log 	: bindLogger('log'),
			trace 	: function(){
				this.logMessage.trace();
			},
			warn 	: bindLogger('warn'),
			/**
			 * Convenience check to verify that we are 'above'
			 * the level of debugging.  
			 * @return {boolean} Returns true if debugging is enabled.
			 */
			isDebugEnabled:function() {
				return (levels.debug>=this.level) 
			},
			/**
			 * Check the currently set logging level.
			 * @return {string} String representation of the logging level.
			 * @see  levels
			 */
			getLevel : function(){
				return this.level;
			},
			setLevel : function(level){
				this.level= levels[level] ? level : 'none';
			},
			/**
			 * Apply optional config properties to the logger.
			 * User this to set level and grouping.
			 * @param  {object} opts Config options for the logger.
			 * @example 
			 * 		Curveball.Log.config({
			 * 			level 		: "none", 	// set the log level
			 * 			grouping 	: false  	// disable grouping,
			 * 			useAlert    : true  	// enable alert
			 *   	});
			 */
			config   : function(opts){
				extend(this,opts);

				if(!this.grouping && group.current || this.level==='none'){
					group.end(group.current);
				}
			}
		};

		var GlobalAppConsole=extend(function(props){
				return new AppConsole(props);
			},new AppConsole(globalConfig),true);
		GlobalAppConsole.logMessage.ctx=GlobalAppConsole;
		return GlobalAppConsole;
	});
})(typeof require!=='undefined' && typeof define!=='undefined' && define || function(_deps,c){
	if(typeof module!=='undefined' && module.exports){
		_deps.shift();
		_deps.shift();
		var rjs=require('requirejs'),
			path=require('path');
		
		rjs.config({
			nodeIdCompat : true,
			baseUrl 	 : path.dirname(module.filename)
		});
		var deps=_deps.map(function(path){
				return rjs(path + '.js');
			});
		deps.unshift(module);
		deps.unshift(rjs);

		module.exports=c.apply(c,deps);
	}
});
